import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "main_bm" }
const _hoisted_2 = { style: {"width":"15%","height":"100%"} }
const _hoisted_3 = { class: "flexBetween left" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, "部门名称", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode("+")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("E")
const _hoisted_7 = { class: "list_search" }
const _hoisted_8 = { class: "search_header" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", {
  class: "flexWrap",
  style: {"width":"80%"}
}, null, -1)
const _hoisted_10 = {
  class: "header_twonr",
  style: {"margin-top":"20px"}
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("添加")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Excel导入")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_15 = {
  class: "flexEnd",
  style: {"padding":"20px"}
}
const _hoisted_16 = { class: "my-header" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", null, "添加部门", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1)
const _hoisted_19 = { class: "flexCenter" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode("删 除")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("提 交")
const _hoisted_22 = { class: "my-header" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", null, "添加部门人员", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1)
const _hoisted_25 = { class: "flexCenter" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode("提 交")
const _hoisted_27 = { class: "my-header" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", null, "Excel导入", -1)
const _hoisted_29 = { class: "my-header" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", null, "Excel导入", -1)

import { CirclePlus,Search } from '@element-plus/icons-vue';
    import { ref,onMounted,computed,nextTick } from 'vue';
    import {
        requestBmList,
        requestBmAdd,
        requestBmDetails,
        requestBmDel,
        requestBmUser,
        requestBmUserAdd,
        requestBmUserDel,
        requestdelall
    } from '@/api/departmentApi.js'
    import Excel from '@/components/Excel'
    import {
        requestAllUser
    } from '@/api/api.js';
	import { ElMessage,ElMessageBox } from 'element-plus';
    
export default /*#__PURE__*/_defineComponent({
  name: 'Department',
  setup(__props) {

	const tableData = ref<any[]>([])
	const loading = ref<boolean>(false)
    const pageIndex = ref<number>(1)
	const pageSize = ref<number>(10)
    const excelShow= ref<boolean>(false)
    const exceladdShow = ref<boolean>(false)
    const excelShow1= ref<boolean>(false)
    const exceladdShow1 = ref<boolean>(false)
	const pages = ref({
		totalCount:0
	})
	const search = ref({
		name:''
	})
    const rightShow = ref(false)
    const addleftShow = ref(false)
    const form = ref({
        id:0,
        pid:'',
        departmentname:'',
        text:''
    })
    const addBmList = ref<any[]>([])
    const ryid = ref(0)//部门列表id
    const addrightShow = ref(false)
    const depart = ref({
        userid:''
    })
    const allUserList = ref<any[]>([])//用户列表
    const departmentuserid = ref(0)//修改部门人员表id
    const bmryList = ref([])//当前部门人员
    onMounted(()=>{
        getAllUser();
        getBm();
    })
    //添加部门根目录点击
    const pidChange = (val:string) => {
        requestBmUser({
            pageIndex:1,
			pageSize:300,
            departmentid:val
        }).then((res:any)=>{
            bmryList.value = res.datalist.DataMap
		})
    }
    //部门人员详情
    const ryDetails = (row:any) => {
        depart.value.userid = row.cell.id
        departmentuserid.value = row.cell.departmentuserid
        addrightShow.value = true
    }
    //删除部门人员
    const ryDel = (row:any) => {
        requestBmUserDel({
            id:row.cell.departmentuserid
        }).then((res:any)=>{
            if(res.status === 1){
			    ElMessage({
			        message: "删除成功",
			        type: 'success',
			        duration: 500
			    });
				setTimeout(()=>{
                    searchList();
				},500)
			}
        })
    }
    const rysubmit = () => {
        if(depart.value.userid == ""){
            ElMessage({
                message: '请选择用户人员',
                type: 'error',
                duration:1500
            })
            return
        }
        requestBmUserAdd({
            departmentid:ryid.value,
            userid:depart.value.userid,
            id:departmentuserid.value
        }).then((res:any)=>{
            if(res.status === 1){
                ElMessage({
			        message: "提交成功",
			        type: 'success',
			        duration: 500
			    });
				setTimeout(()=>{
					addrightShow.value = false
                    searchList();
				},500)
            }else{
                ElMessage({
                    message:res.msg,
                    type: 'error',
                    duration:500
                })
            }
        })
    }
    //获取所有人员
    const getAllUser = () => {
        requestAllUser().then((res:any)=>{
            if(res.status === 1){
                allUserList.value = res.datalist
            }
        })
    }
    const bmList = computed(()=>{
        let cloneData = JSON.parse(JSON.stringify(addBmList.value))
        return cloneData.filter((father:any)=>{        
            let branchArr = cloneData.filter((child:any)=>father.id == child.pid)  //返回每一项的子级数组
            branchArr.length>0 ? father.children = branchArr : ''  //如果存在子级，则给父级添加一个children属性，并赋值
            return father.pid==0;   //返回第一层
        });
    })
    const getBm = () => {
        requestBmList().then((res:any)=>{
            if(res.status === 1){
                addBmList.value = res.datalist
            }
        })
    }
    const getList = (departmentid:any) => {
        requestBmUser({
            pageIndex:pageIndex.value,
			pageSize:300,
            departmentid:departmentid
        }).then((res:any)=>{
			tableData.value = res.datalist.DataMap
			pages.value.totalCount = res.totalCount
			loading.value = false
		})
    }
    //删除部门
    const bmDel = () => {
        requestBmDel({
            id:form.value.id
        }).then((res:any)=>{
            if(res.status === 1){
			    ElMessage({
			        message: "删除成功",
			        type: 'success',
			        duration: 500
			    });
				setTimeout(()=>{
					addleftShow.value = false
                    getBm();
				},500)
			}
        })
    }
    const delBmAll = () => {
        requestdelall({
            departmentid:form.value.pid
        }).then((res:any)=>{})
    }

    const excelsx = () =>{
        excelShow.value = false
        nextTick(()=>{
            excelShow.value = true
        })
    }
    const excelcancel = () => {
        exceladdShow.value = false
        getBm();
    }
    const exceladd = ()=>{
        excelsx();
        exceladdShow.value = true
    }
    ///
     const excelsx1 = () =>{
        excelShow1.value = false
        nextTick(()=>{
            excelShow1.value = true
        })
    }
    const excelcancel1 = () => {
        exceladdShow1.value = false
        searchList();
    }
    const exceladd1 = ()=>{
        excelsx1();
        exceladdShow1.value = true
    }
    //部门提交封装
    const bmsubmit1 = () => {
        requestBmAdd({
            id:form.value.id,
            pid:form.value.pid,
            departmentname:form.value.departmentname,
            text:form.value.text
        }).then((res:any)=>{
            if(res.status === 1){
                ElMessage({
                    message: "提交成功",
                    type: 'success',
                    duration: 500
                });
                setTimeout(()=>{
                    addleftShow.value = false
                    getBm();
                },500)
            }
        })
    }
    //部门提交
    const bmsubmit = () => {
        if(form.value.departmentname == ""){
            ElMessage({
                message: '请输入部门名称',
                type: 'error',
                duration:1500
            })
            return
        }
        if(bmryList.value.length>0){
            ElMessageBox.confirm(
                '提交后将清空当前部门下所有人员，是否提交',
                '消息',
                {
                    confirmButtonText: '是',
                    cancelButtonText: '否',
                    type: 'warning',
                }
            ).then(() => {
                bmsubmit1();
                delBmAll();
            }).catch(() => {
                
            })
            return
        }
        bmsubmit1();
    }
    //添加人员
    const addForm = () => {
        if(ryid.value == 0){
            ElMessage({
                message: '请点击部门',
                type: 'error',
                duration:1500
            })
            return
        }
        depart.value.userid = ''
        departmentuserid.value = 0
        addrightShow.value = true
    }
    const addbmcz = () => {
        form.value = {
            id:0,
            pid:'',
            departmentname:'',
            text:''
        }
    }
    //添加部门
    const addBm = () => {
        addbmcz();
        addleftShow.value = true
    }
    //部门人员列表
    const ryClick = (row:any) => {
        if(row.children){
            rightShow.value = false
        }else{
            ryid.value = row.id
            getList(ryid.value);
            rightShow.value = true
        }
        
    }
    //编辑部门
    const bmCellClick = (row:any) => {
        addbmcz();
        form.value.id = row.id
        requestBmDetails({
            id:row.id
        }).then((res:any)=>{
            if(res.status === 1){
                form.value = {
                    id:res.datalist[0].id,
                    pid:res.datalist[0].pid==0?'':res.datalist[0].pid,
                    departmentname:res.datalist[0].departmentname,
                    text:res.datalist[0].text
                }
                addleftShow.value = true
            }
        })
    }
    const searchList = () =>{
		pageIndex.value = 1
		getList(ryid.value);
	}
    const handleSizeChange = (val: number) =>{
		pageSize.value = val
		getList(ryid.value)
	}
	const handleCurrentChange = (val: number) =>{
		pageIndex.value = val
		getList(ryid.value)
	}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_Close = _resolveComponent("Close")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_table, {
        onCellClick: ryClick,
        onCellDblclick: bmCellClick,
        data: _unref(bmList),
        "header-cell-style": {color:'#000',backgroundColor:'#fafbfd'},
        border: "",
        "row-key": "id",
        "highlight-current-row": ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            label: "",
            prop: "departmentname"
          }, {
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("div", null, [
                  _createVNode(_component_el_button, {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (addBm())),
                    type: "primary",
                    size: "small",
                    style: {"width":"20px","height":"20px","font-size":"22px"}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_button, {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (exceladd())),
                    type: "primary",
                    size: "small",
                    style: {"width":"20px","height":"20px","font-size":"18px"}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])
    ]),
    (rightShow.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          style: _normalizeStyle([{"width":"84%","border":"1px solid #ebeef5"}, tableData.value.length<10?'height:38rem;':''])
        }, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_el_button, {
                  plain: "",
                  type: "primary",
                  size: "small",
                  icon: _unref(Search),
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (searchList()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_11
                  ]),
                  _: 1
                }, 8, ["icon"]),
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (addForm())),
                  size: "small",
                  icon: _unref(CirclePlus)
                }, {
                  default: _withCtx(() => [
                    _hoisted_12
                  ]),
                  _: 1
                }, 8, ["icon"]),
                _createVNode(_component_el_button, {
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (exceladd1())),
                  size: "small",
                  icon: _unref(CirclePlus),
                  type: "primary"
                }, {
                  default: _withCtx(() => [
                    _hoisted_13
                  ]),
                  _: 1
                }, 8, ["icon"])
              ])
            ])
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_table, {
            data: tableData.value,
            "header-cell-style": {color:'#000',backgroundColor:'#fafbfd'}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                type: "index",
                width: "80",
                label: "序号",
                align: "center"
              }),
              _createVNode(_component_el_table_column, {
                prop: "cell.code",
                label: "编号",
                width: "120"
              }),
              _createVNode(_component_el_table_column, {
                prop: "cell.name",
                label: "姓名",
                width: "150"
              }),
              _createVNode(_component_el_table_column, {
                prop: "cell.tel",
                label: "手机",
                width: "120"
              }),
              _createVNode(_component_el_table_column, {
                prop: "cell.area",
                label: "区域",
                width: "120"
              }),
              _createVNode(_component_el_table_column, {
                prop: "cell.rolelist",
                label: "角色",
                width: "80"
              }),
              _createVNode(_component_el_table_column, { label: "操作" }, {
                default: _withCtx((scope) => [
                  _createVNode(_component_el_button, {
                    link: "",
                    type: "danger",
                    size: "small",
                    onClick: ($event: any) => (ryDel(scope.row))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_14
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"])), [
            [_directive_loading, loading.value]
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_el_pagination, {
              onSizeChange: handleSizeChange,
              onCurrentChange: handleCurrentChange,
              currentPage: pageIndex.value,
              "onUpdate:currentPage": _cache[5] || (_cache[5] = ($event: any) => ((pageIndex).value = $event)),
              "page-sizes": [10, 20, 30],
              "page-size": pageSize.value,
              "onUpdate:page-size": _cache[6] || (_cache[6] = ($event: any) => ((pageSize).value = $event)),
              layout: "total, sizes, prev, pager, next, jumper",
              total: pages.value.totalCount
            }, null, 8, ["currentPage", "page-size", "total"])
          ])
        ], 4))
      : _createCommentVNode("", true),
    _createVNode(_component_el_dialog, {
      modelValue: addleftShow.value,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((addleftShow).value = $event)),
      "show-close": false,
      "close-on-click-modal": false
    }, {
      header: _withCtx(({ close, titleId, titleClass }) => [
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createVNode(_component_el_icon, {
            class: "delicon",
            onClick: close
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Close)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          style: {width:'90%'},
          "label-width": "100px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "上级部门" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  onChange: pidChange,
                  modelValue: form.value.pid,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.value.pid) = $event)),
                  placeholder: "请选择",
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "根目录",
                      value: ""
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(addBmList.value, (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: item.departmentname,
                        value: item.id,
                        key: index
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "部门名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.value.departmentname,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.value.departmentname) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "描述" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.value.text,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.value.text) = $event)),
                  type: "textarea"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _hoisted_18,
        _createElementVNode("div", _hoisted_19, [
          (form.value.id!=0)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                onClick: _cache[10] || (_cache[10] = ($event: any) => (bmDel())),
                type: "danger"
              }, {
                default: _withCtx(() => [
                  _hoisted_20
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_button, {
            onClick: _cache[11] || (_cache[11] = ($event: any) => (bmsubmit())),
            type: "primary"
          }, {
            default: _withCtx(() => [
              _hoisted_21
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: addrightShow.value,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((addrightShow).value = $event)),
      "show-close": false,
      "close-on-click-modal": false
    }, {
      header: _withCtx(({ close, titleId, titleClass }) => [
        _createElementVNode("div", _hoisted_22, [
          _hoisted_23,
          _createVNode(_component_el_icon, {
            class: "delicon",
            onClick: close
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Close)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          style: {width:'90%'},
          "label-width": "100px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "用户人员" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  filterable: "",
                  modelValue: depart.value.userid,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((depart.value.userid) = $event)),
                  placeholder: "请选择",
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allUserList.value, (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: `${item.name}(${item.code})`,
                        value: item.id,
                        key: index
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _hoisted_24,
        _createElementVNode("div", _hoisted_25, [
          _createVNode(_component_el_button, {
            onClick: _cache[14] || (_cache[14] = ($event: any) => (rysubmit())),
            type: "primary"
          }, {
            default: _withCtx(() => [
              _hoisted_26
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "Excel导入",
      modelValue: exceladdShow.value,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((exceladdShow).value = $event)),
      "show-close": false
    }, {
      header: _withCtx(({ close, titleId, titleClass }) => [
        _createElementVNode("div", _hoisted_27, [
          _hoisted_28,
          _createVNode(_component_el_icon, {
            class: "delicon",
            onClick: _cache[16] || (_cache[16] = ($event: any) => (exceladdShow.value=false))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Close)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        (excelShow.value)
          ? (_openBlock(), _createBlock(_unref(Excel), {
              key: 0,
              onCancel: _cache[17] || (_cache[17] = ($event: any) => (excelcancel())),
              id: "组织架构导入"
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "Excel导入",
      modelValue: exceladdShow1.value,
      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((exceladdShow1).value = $event)),
      "show-close": false
    }, {
      header: _withCtx(({ close, titleId, titleClass }) => [
        _createElementVNode("div", _hoisted_29, [
          _hoisted_30,
          _createVNode(_component_el_icon, {
            class: "delicon",
            onClick: _cache[19] || (_cache[19] = ($event: any) => (exceladdShow1.value=false))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Close)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        (excelShow1.value)
          ? (_openBlock(), _createBlock(_unref(Excel), {
              key: 0,
              onCancel: _cache[20] || (_cache[20] = ($event: any) => (excelcancel1())),
              id: "组织架构导入用户"
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})